module.exports = __webpack_public_path__ + "img/started-deliveries.96d8d07d.svg";